
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Cards2","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_15301","data-name":"Rectangle 15301","width":"30","height":"30","fill":"none"}}),_c('g',{attrs:{"id":"Group_45497","data-name":"Group 45497"}},[_c('g',{attrs:{"id":"Group_45499","data-name":"Group 45499"}},[_c('path',{attrs:{"id":"Path_32708","data-name":"Path 32708","d":"M14.95 11.12H7.5a.75.75 0 000 1.5h7.45a.75.75 0 000-1.5","fill":"#fff"}}),_c('path',{attrs:{"id":"Path_32709","data-name":"Path 32709","d":"M12 14.12H7.5a.75.75 0 000 1.5H12a.75.75 0 000-1.5","fill":"#fff"}}),_c('path',{attrs:{"id":"Path_32710","data-name":"Path 32710","d":"M22.5 7.2h-15a3.751 3.751 0 00-3.75 3.75v8.1A3.751 3.751 0 007.5 22.8h15a3.758 3.758 0 003.75-3.75v-8.1A3.758 3.758 0 0022.5 7.2M6.75 14.87a.749.749 0 01.748-.75H12a.75.75 0 010 1.5H7.5a.743.743 0 01-.75-.736v-.014m8.2-2.25H7.5a.75.75 0 010-1.5h7.45a.75.75 0 010 1.5","fill":"#5555f2"}})])])])
          )
        }
      }
    